import { useRef } from 'react'

import { SsoExchangeServiceAPI } from '../../services/SsoExchangeService/index.api'

const useSsoExchangeService = (): SsoExchangeServiceAPI => {
   const ssoExchangeServiceRef = useRef(new SsoExchangeServiceAPI())

   return ssoExchangeServiceRef.current
}

export { useSsoExchangeService }
